import React, { PropsWithChildren } from 'react';

interface CardProps {
    className?: string | undefined;
    style?: React.CSSProperties | undefined;
    title?: string | React.ReactNode | undefined;
    titlePrefix?: React.ReactNode | undefined;
    titlePostfix?: React.ReactNode | undefined;
}

export const OCard: React.FC<CardProps & PropsWithChildren> = (props) => {
    return (
        <div className={"p-4 bg-gray-100 rounded-lg shadow-lg flex flex-col justify-items-start " + props.className} style={props.style}>
            {(props.titlePrefix || props.title || props.titlePostfix) && (
                <div className="flex justify-content-between justify-items-start">
                    <div className="flex pb-4 items-center text-lg">
                        {(props.titlePrefix) && (<>{props.titlePrefix}</>)}
                        {(props.title) && (<div className="font-semibold font-">{props.title}</div>)}
                    </div>
                    {(props.titlePostfix) && (<>{props.titlePostfix}</>)}
                </div>
            )}
            {props.children}
        </div>
    );
};

// <div className="bg-gray-50 p-6 rounded-lg shadow">
//     <div className="flex items-center mb-4">
//         <img
//             src="/images/testimonial-jan.svg"
//             alt="Jan de Vries"
//             className="w-12 h-12 rounded-full object-cover mr-4"
//         />
//         <div>
//             <h4 className="font-bold">Jan de Vries</h4>
//             <p className="text-sm text-gray-600">Ondernemer, 52 jaar</p>
//         </div>
//     </div>
//     <p className="text-gray-700">
//         "Dankzij PensioenZeker heb ik eindelijk inzicht in mijn pensioen. Hun adviseurs hebben mij geholpen met een plan dat perfect past bij mijn situatie als ondernemer."
//     </p>
// </div>
